import { faEllipsisH, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { round } from "lodash";
import * as React from "react";
import {
  Badge,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import useToggle from "../../hooks/use-toggle";
import { formatDe } from "../../utils/date";
import styled from "./DateHeader.styles";

interface DateHeaderProps {
  date: Date;
  active?: boolean;
  duration: number;
  deleteAllEntries(): void;
}

const DateHeader: React.FC<DateHeaderProps> = (props) => {
  const { date, active, duration, deleteAllEntries } = props;
  const [showMenu, toggleMenu] = useToggle(false);

  return (
    <styled.Container>
      <styled.Headline active={active}>
        &nbsp;{formatDe(date, "dd.MM. iiii")}{" "}
        <Badge pill color="info">
          {round(duration / 3600000, 1)}h
        </Badge>{" "}
        &nbsp;
      </styled.Headline>
      {duration > 0 && (
        <Dropdown isOpen={showMenu} toggle={toggleMenu}>
          <DropdownToggle
            data-test="date-header-dropdown-toggle"
            size="sm"
            color="link"
          >
            <FontAwesomeIcon icon={faEllipsisH} color="#6c757d" />
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem
              data-test="date-header-delete-all"
              onClick={deleteAllEntries}
            >
              <FontAwesomeIcon icon={faTrash} /> Alle Einträge entfernen
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      )}
    </styled.Container>
  );
};

export default DateHeader;
